import { render, staticRenderFns } from "./shopPhone.vue?vue&type=template&id=319268fb&"
import script from "./shopPhone.vue?vue&type=script&lang=js&"
export * from "./shopPhone.vue?vue&type=script&lang=js&"
import style0 from "./shopPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports